module.exports = __webpack_public_path__ + "static/android-chrome-256x256-956bb82b3f8e6ce54431740df165a5ae.png";